import {
    Box,
    Heading,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableHeader,
    TableRow,
} from '@ksyos/design-system';
import { FormatCurrency } from '@frontend/components/elements/FormatCurrency';
import { NullableFormattedDate } from '@frontend/components/elements/NullableFormattedDate';
import { getSelectedLanguage } from '@frontend/translate';
import type { InvoiceRecord } from '../adminProcessDetailsTypes';

type InvoiceRecordsProps = {
    invoiceRecords?: InvoiceRecord[];
    label: string;
};

export function InvoiceRecords({ invoiceRecords, label }: InvoiceRecordsProps): JSX.Element | null {
    if (!invoiceRecords || invoiceRecords.length === 0) {
        return null;
    }

    const translate = getSelectedLanguage();

    return (
        <Box marginBottom={3}>
            <Heading
                as="h3"
                fontWeight="bold"
                marginBottom={1}
                size="small"
            >
                {label}:
            </Heading>
            <TableContainer>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableHeader>{translate.organization.relationNumber}</TableHeader>
                            <TableHeader>{translate.finance.requesterGroup}</TableHeader>
                            <TableHeader>{translate.finance.providerOrganization}</TableHeader>
                            <TableHeader>{translate.finance.invoiceDate}</TableHeader>
                            <TableHeader>{translate.export.runDate}</TableHeader>
                            <TableHeader>{translate.finance.amount}</TableHeader>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {invoiceRecords.map((invoiceRecord, index) => (
                            <TableRow key={`${invoiceRecord.id}${index}`}>
                                <TableCell>
                                    {invoiceRecord.requesterGroupRelationNumber ||
                                        invoiceRecord.providerOrganizationRelationNumber}
                                </TableCell>
                                <TableCell>{invoiceRecord.requesterGroup}</TableCell>
                                <TableCell>{invoiceRecord.providerOrganization}</TableCell>
                                <TableCell>
                                    <NullableFormattedDate value={invoiceRecord.invoiceDate} />
                                </TableCell>
                                <TableCell>
                                    <NullableFormattedDate value={invoiceRecord.runDate} />
                                </TableCell>
                                <TableCell>
                                    <FormatCurrency value={invoiceRecord.amount} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Box>
    );
}
